import i18n from '@/assets/i18n/index'
const objConfig = {
  // 基础信息
  baseInfo: {
    logo: require('@/assets/img/logo4.png'),
    login:i18n.t('topItem.login'),
  },
  // 公司详细信息
  companyDetail: {
    logo: require('@/assets/img/home/logo_bottom.png'),
    name: '飞坦（深圳）数字物流科技有限公司',
    address: '深圳市龙华区五和大道雅宝路1号星河World D栋6E',
    phone: '13410690014',
    email: 'Fleetan@dlvd.com',
    website: 'https://fleetan.com',
    qrcode: require('@/assets/img/wx.jpg'),
    officialAccounts: require('@/assets/img/wx.jpg'),
    rightFixQrcode: require('@/assets/img/qrCode.png'),
    phoneLogo: require('@/assets/img/contactPhone.png'),
  },
  //核心业务
  mainService: [{
      title: '中东FBA/FBN专线',
      blurbRow1: '空运时效5-7，海运时效约35天',
      blurbRow2: 'FBA免预约送仓，FBN送仓成功率高',
      content: '',
      url: "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/FBA.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=WQr9k9uavY%2FsWWItsdtF336%2FCuU%3D",
      alignType: 'left',
    },
    {
      title: '空运/海运门到门',
      blurbRow1: '提供中东本地收货人、报关、清关、SABER证书、本地派送、回款等全套物流服务',
      blurbRow2: '',
      content: '',
      url: "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/air2.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=MgJzb6nQoZpEHyQ7gQ27dPec4Ys%3D",
      alignType: 'left',
    },
    {
      title: '海外仓',
      blurbRow1: '中东自营海外仓(沙特/阿联酋)',
      blurbRow2: '提供FBA/FBN暂存转运、一件代发、退货换标等全方位服务',
      content: '',
      url: "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/owh2.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=aQ6lBoG6F5jq4g2583hW8fxnWMM%3D",
      alignType: 'left',
    },
    {
      title: '海运整柜清关',
      blurbRow1: '自有清关行，专业的清关团队，',
      blurbRow2: '丰富的证书清关经验，提供多种清关方案',
      content: '',
      url: "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/fcl3.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=GKN1BTyOfjTNRHzs3OpnmEuntmo%3Dg",
      alignType: 'left',
    },
    {
      title: 'Saber证书',
      blurbRow1: 'Saber注册，快速注册',
      blurbRow2: 'SC可当天出证',
      content: '',
      url: "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/package4.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=HbZf67wpbdAYiPiCeF8%2Bs7kNlUo%3D",
      alignType: 'center',
    },
    {
      title: 'B2C小包',
      blurbRow1: '自有海外仓+成熟本土派送团队，签收率高，时效快，提供COD解决方案',
      blurbRow2: '',
      content: '',
      url: "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/package.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=vOp9d8pq10d3cIVpFHod%2BQ0sklc%3D",
      alignType: 'left',
    }
  ],

  // 服务优势
  serviceAdvantage: {
    countData: [
      {
        icon:require('@/assets/img/advantage/count_partner.png'),
        count:50,
        suffix:'+',
        text:'合作方数量',
      },
      {
        icon:require('@/assets/img/advantage/count_client.png'),
        count:5000,
        suffix:'+',
        text:'服务客户数量',
      },
      {
        icon:require('@/assets/img/advantage/owhArea.png'),
        count:10000,
        suffix:'+',
        text:'仓储面积',
      },
      {
        icon:require('@/assets/img/advantage/count_successRate.png'),
        count:80,
        suffix:'%',
        text:'平均签收率',
      },

    ],
    detailData: [{
        icon:require('@/assets/img/advantage/technology.png'),
        title: '强科技 优系统',
        // content: '原阿里技术高管领衔，坚持科技赋能物流，自主研发的数字化管理系统，依托大数据智能解析，<strong>实现高危订单拦截，物流路由动态切换，实时跨境回款等增值服务，</strong>优化物流全链路，提升物流时效，加强货物安全监管，降低物流成本',
        content:'自主研发的数字化管理系统，<strong>实现高危订单拦截，物流路由动态切换，实时跨境回款等增值服务，</strong>优化物流全链路，提升物流时效，加强货物安全监管，降低物流成本',
      },
      {
        icon:require('@/assets/img/advantage/data.png'),
        title: '广增值 全赋能',
        content: '借助大数据分析，定期输出服务追踪反馈，反向赋能，帮助客户提升妥投率，为客户决策提供全方位依据',
      },
      {
        icon:require('@/assets/img/advantage/time.png'),
        title: '渠道稳 时效快',
        content: '一手资源，仓位稳定，<strong>空派时效5-7天，FBA/FBN全程时效8-10天（含送仓）</strong>',
      },
      {
        icon:require('@/assets/img/advantage/major.png'),
        title: '专业高 出证快',
        content: '自有清关渠道，专业清关团队，提供中东收货人和全套物流解决文案，SABER注册，快速出证，SC可当天出证',
      },
      {
        icon:require('@/assets/img/advantage/money.png'),
        title: '妥投高 回款快',
        content: '自建海外仓，自有本土派送团队，<strong>COD妥投率高，周结回款，</strong>加快资金周转，降低资金风险',
      },
      {
        icon:require('@/assets/img/advantage/safe.png'),
        title: '重安全 有保障',
        content: '重视货物安全，通过数字系统实时跟踪物流轨迹，每个环节都有据可查',
      }
    ]
  },

  // 合作伙伴
  partners: [
    {
      name:'',
      logo:require('@/assets/img/partner/amazon.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/NOON.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/anker.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/fordeal.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/gfs.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/aranex.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/aeAir.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/chinaPost.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/cosco.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/everGreen.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/MAERSK.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/naqel.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/oocl.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/poly.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/railway18.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/SV.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/tomtop.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/uGreen.png'),
      url:'',
    },

  ],
  // 首页菜单
  menuList: [
    {
      title: i18n.t('topItem.home'),
      index: '/home',
      hasSub: false,
      link: '',
    },
    {
      title: '核心业务',
      index: '/mainService',
      hasSub: true,
      subList: [{
          title: 'FBA/FBN专线',
          index: '/mainServiceInfo_one',
          link: '',
        },
        {
          title: '空运/海运门到门',
          index: '/mainServiceInfo_two',
          link: '',
        },
        {
          title: '海外仓',
          index: '/mainServiceInfo_three',
          link: '',
        },
        {
          title: '海运整柜清关',
          index: '/mainServiceInfo_four',
          link: '',
        },
        {
          title: 'Saber证书',
          index: '/mainServiceInfo_five',
          link: '',
        },
        {
          title: 'B2C小包',
          index: '/mainServiceInfo_six',
          link: '',
        },
      ]
    },
    {
      title: '物流追踪',
      index: '/tracking',
      hasSub: false,
      link: '',
    },
    {
      title: '新闻资讯',
      index: '/news',
      hasSub: false,
      link: '',
    },
    {
      title: '关于我们',
      index: 'aboutUs',
      hasSub: true,
      subList: [{
          title: '公司简介',
          index: '/aboutUs_one',
          link: '',
        },
        {
          title: '发展历程',
          index: '/aboutUs_two',
          link: '',
        },
        {
          title: '合作单位',
          index: '/aboutUs_three',
          link: '',
        },
        {
          title: '联系我们',
          index: '/aboutUs_four',
          link: '',
        }
      ],
    },
  ]
}

export default objConfig



// WEBPACK FOOTER //
// ./src/view/homePage/mainjson.js